/**
 * 预付码
 * 已验证 但是未绑定到订单的 存储在 sessionStorage，关闭浏览器后销毁
 * 已经绑定在订单的 存储在 localStorage，下次进入还需要展示
 */

const BOUND_PREFIX = 'PREPAID_BOUND_AMOUNT_';
const CODE_PREFIX = 'PREPAID_CODES_';
const AVAILABLE_PREFIX = 'PREPAID_AVAILABLE_AMOUNT_';

// 设置已和订单绑定的预付金金额
export const setPrepaidBoundAmount = (orderId, amount) =>
  localStorage.setItem(`${BOUND_PREFIX}${orderId}`, amount);

// 设置已和订单绑定的可用的预付金金额
export const setPrepaidAvailableAmount = (orderId, amount) =>
  localStorage.setItem(`${AVAILABLE_PREFIX}${orderId}`, amount);

export const getPrepaidCodes = shopId =>
  JSON.parse(sessionStorage.getItem(`${CODE_PREFIX}${shopId}`) || '[]');

// 获取总的预付金的总额
export const getPrepaidTotalAmount = (shopId, orderId) => {
  const freshAmount = getPrepaidCodes(shopId).reduce(
    (total, item) => total + Number(item.prepayAmount),
    0
  );
  const boundAmount = Number(localStorage.getItem(`${BOUND_PREFIX}${orderId}`));

  return freshAmount + boundAmount;
};

// 获取可用的总的预付金金额
export const getPrepaidAvailableAmount = (shopId, orderId) => {
  const boundAmount = Number(localStorage.getItem(`${AVAILABLE_PREFIX}${orderId}`));
  const freshAmount = getPrepaidCodes(shopId).reduce(
    (total, item) => total + Number(item.prepayAmount),
    0
  );

  return freshAmount + boundAmount;
};

export const clearPrepaidCodes = (shopId, codes = []) => {
  if (!codes.length) {
    sessionStorage.removeItem(`${CODE_PREFIX}${shopId}`);
  } else {
    const oldCodes = getPrepaidCodes(shopId);
    const update = oldCodes.filter(item => codes.indexOf(item.prepayCode) === -1);

    sessionStorage.setItem(`${CODE_PREFIX}${shopId}`, JSON.stringify(update));
  }
};



// WEBPACK FOOTER //
// ./src/helper/prepaid-code.js